export default [
  //General Routes
  {
    path: "/",
    name: "Dashboard",
    component: () =>
      import(/* webpackChunkName: "Dashboard" */ "../views/index.vue"),
    meta: {
      layout: "default",
      middleware: [require("@/middleware/isAuth").default],
      title: "tassis_school_system",
      description: "welcome_to_tasis_system_school",
    },
  },
  {
    path: "/profile",
    name: "Profile",
    component: () =>
      import(/* webpackChunkName: "Profile" */ "../views/profile.vue"),
    meta: {
      layout: "default",
      middleware: [require("@/middleware/isAuth").default],
      title: "manage_profile",
      description: "manage_organize_profile",
    },
  },
  {
    path: "/error/:errorMessage",
    name: "ErrorPage",
    component: () => import(/* webpackChunkName: "error" */ "@/views/error/"),
    props: true,
    meta: {
      layout: "default",
      title: "something_error",
      middleware: [require("@/middleware/isAuth").default],
    },
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/error/404 Not Found",
  },
];
